import { authServer } from '@/core/firebase'
import { useSendVerificationCodeStore } from '../store/phone-login-store'

export const useSendVerificationCode = () => {
  const {
    setVerificationId,
    setPhoneNumber,
    setIsPending,
    reset,
    isPending,
    verificationId,
    phoneNumber,
  } = useSendVerificationCodeStore()

  const sendCode = async (phone: string) => {
    try {
      setIsPending(true)
      setPhoneNumber(phone)
      const verificationId = await authServer.loginWithPhoneNumber(phone, {
        onCaptchaClosed: () => setIsPending(false),
      })

      setVerificationId(verificationId)
    } catch (err) {
      reset()
      setIsPending(false)
      throw err
    } finally {
      setIsPending(false)
    }
  }

  return { sendCode, isPending, verificationId, phoneNumber }
}
